export default __webpack_public_path__ + "static/media/transpaleta1.22ac202d.jpg";